import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Message from '../../components/Message';
import { formatDateTime } from '../../utils/formatDate';

type PropsType = {
  startDate: string;
  timeZone: string;
  utcStartDate: number;
};

const Wrapper = styled.div`
  margin: var(--space-150) 0 0 0;
`;

const RegistrationStartDate = ({
  startDate,
  utcStartDate,
  timeZone = '',
}: PropsType) => {
  const { t } = useTranslation();

  if (!startDate || utcStartDate < Date.now()) {
    return null;
  }

  const date = formatDateTime(startDate, timeZone);

  return (
    <Wrapper>
      <Message subtle>{t('event.registrationStarts', { date })}</Message>
    </Wrapper>
  );
};

export default RegistrationStartDate;
